// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-toolbar {
  --background: var(--ion-color-light);
  --color: var(--ion-color-dark);
}

.back-icon {
  color: var(--ion-color-dark);
  font-size: 24px;
}

.page-title {
  font-size: 20px;
  font-weight: 500;
}

.transparent-list {
  background: transparent;
}

.transparent-item {
  --background: rgba(255, 255, 255, 0.15);
  --border-color: transparent;
  margin: 8px 0;
  border-radius: 8px;
  --color: var(--ion-color-light);
}

.section-title {
  margin-top: 20px;
}

.section-title ion-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-light);
}

.menu-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 56px;
  --color: var(--ion-color-light);
}

.menu-icon {
  color: var(--ion-color-light);
  font-size: 24px;
  margin-right: 16px;
}

ion-label {
  color: var(--ion-color-light);
  font-size: 16px;
  font-weight: 500;
}

ion-icon[slot=end] {
  color: var(--ion-color-light);
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/account/about/about.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,8BAAA;AACJ;;AAEE;EACE,4BAAA;EACA,eAAA;AACJ;;AAEE;EACE,eAAA;EACA,gBAAA;AACJ;;AAEE;EACE,uBAAA;AACJ;;AAEE;EACE,uCAAA;EACA,2BAAA;EACA,aAAA;EACA,kBAAA;EACA,+BAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AACJ;;AAEE;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;AACJ;;AAEE;EACE,6BAAA;EACA,eAAA;EACA,kBAAA;AACJ;;AAEE;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEE;EACE,6BAAA;EACA,eAAA;AACJ","sourcesContent":[".custom-toolbar {\r\n    --background: var(--ion-color-light);\r\n    --color: var(--ion-color-dark);\r\n  }\r\n  \r\n  .back-icon {\r\n    color: var(--ion-color-dark);\r\n    font-size: 24px;\r\n  }\r\n  \r\n  .page-title {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .transparent-list {\r\n    background: transparent;\r\n  }\r\n  \r\n  .transparent-item {\r\n    --background: rgba(255, 255, 255, 0.15);\r\n    --border-color: transparent;\r\n    margin: 8px 0;\r\n    border-radius: 8px;\r\n    --color: var(--ion-color-light);\r\n  }\r\n  \r\n  .section-title {\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .section-title ion-title {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: var(--ion-color-light);\r\n  }\r\n  \r\n  .menu-item {\r\n    --padding-start: 16px;\r\n    --padding-end: 16px;\r\n    --min-height: 56px;\r\n    --color: var(--ion-color-light);\r\n  }\r\n  \r\n  .menu-icon {\r\n    color: var(--ion-color-light);\r\n    font-size: 24px;\r\n    margin-right: 16px;\r\n  }\r\n  \r\n  ion-label {\r\n    color: var(--ion-color-light);\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  ion-icon[slot=\"end\"] {\r\n    color: var(--ion-color-light);\r\n    font-size: 20px;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
